import { DominoConfig } from '@models/venue/integrations/DominoConfig'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { DOMINO_CONFIGS_URL } from '@utils/urls'

const fetchDominoConfigs = (params: TableParams) =>
  SBAPI.FetchPaginated<DominoConfig[]>(DOMINO_CONFIGS_URL, params)

const fetchDominoConfigById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<DominoConfig>(`${DOMINO_CONFIGS_URL}/${id}`, params)

const createDominoConfig = (DominoConfig: DominoConfig) =>
  SBAPI.Post(DOMINO_CONFIGS_URL, DominoConfig)

const updateDominoConfig = (DominoConfig: DominoConfig) =>
  SBAPI.Put(`${DOMINO_CONFIGS_URL}/${DominoConfig.id}`, DominoConfig)

const deleteDominoConfig = (DominoConfig: DominoConfig) =>
  SBAPI.Delete(`${DOMINO_CONFIGS_URL}/${DominoConfig.id}`)

export {
  createDominoConfig,
  deleteDominoConfig,
  fetchDominoConfigById,
  fetchDominoConfigs,
  updateDominoConfig,
}
